<app-auth-view>
  <ng-container slot="title">{{ title() }}</ng-container>
  <ng-container slot="message">{{ message() }}</ng-container>

  <ng-container slot="content">
    <form [formGroup]="tenantForm" (ngSubmit)="onSubmit()" class="flex flex-col gap-4 mt-10">
      <div class="space-y-2">
        <label for="tenantName" class="block font-medium text-sm select-none">
          Organisatienaam invoeren
        </label>

        <mat-form-field class="w-full">
          <input
            matInput
            formControlName="tenantName"
            id="tenantName"
            type="text"
          />

          @if (tenantForm.get('tenantName')?.hasError('required')) {
            <mat-error>Organisatienaam is verplicht</mat-error>
          }
          @if (tenantForm.get('tenantName')?.hasError('minlength')) {
            <mat-error>Organisatienaam moet minimaal 2 tekens bevatten</mat-error>
          }
          @if (tenantForm.get('tenantName')?.hasError('maxlength')) {
            <mat-error>Organisatienaam mag maximaal 50 tekens bevatten</mat-error>
          }
        </mat-form-field>

        @if (errorMessage()) {
          <p class="text-sm text-red-600">
            {{ errorMessage() }}
          </p>
        }
      </div>

      <button mat-flat-button [disabled]="isLoading() || tenantForm.invalid">
        @if (isLoading()) {
          <span>Laden...</span>
        } @else {
          <span>{{ buttonText() }}</span>
        }
      </button>
    </form>
  </ng-container>
</app-auth-view>
